import { SuperadminService } from "connection/superadmin-service";
import { checkErrorMessage, getErrorMessage } from "./errors";

const SET_ADMIN_MARKERS = "SET-ADMIN-MARKERS";
const SET_TOPICS_COUNT = "SET-TOPICS-COUNT";
const SET_TOPICS_PAGE = "SET_TOPICS_PAGE";
const SET_MARKER_TOPICS = "SET_MARKER_TOPICS";

const AdminMarkersData = {
    markers: null,
    tableHeader: ['#', {
        name: 'dropdown',
        title: 'ALPHABETIC',
        type: 'index',
        items: [
            {
                title: 'ALPHABETICALLY_A-Z_↓',
                name: 'ALPHABETIC ASC',
                short_name: 'ALPHABETIC DESC'
            },
            {
                title: 'ALPHABETICALLY_Z-A_↑',
                name: 'ALPHABETIC ASC',
                short_name: 'ALPHABETIC ASC'
            }
        ]
    }, 'EMAIL', {
        name: 'dropdown',
        title: 'CREATED_AT',
        type: 'name',
        items: [
            {
                title: 'DATE_CREATED_AT_↓',
                name: 'CREATED_AT DESC',
                short_name: 'CREATED_AT DESC'
            },
            {
                title: 'DATE_CREATED_AT_↑',
                name: 'CREATED_AT ASC',
                short_name: 'CREATED_AT ASC'
            }
        ]
    },
    {
        name: 'dropdown',
        title: 'UPDATED_AT',
        type: 'createdDate',
        items: [
            {
                title: 'DATE_UPDATED_AT_↓',
                name: 'UPDATED_AT DESC',
                short_name: 'UPDATED_AT DESC'
            },
            {
                title: 'DATE_UPDATED_AT_↑',
                name: 'UPDATED_AT ASC',
                short_name: 'UPDATED_AT ASC'
            },
        ]
    }, {
        name: 'dropdown',
        title: 'STATUS',
        type: 'index',
        items: [
            {
                title: 'ALL',
                name: 'ALL',
                short_name: 'ALL'
            },
            {
                title: 'ACTIVE',
                name: 'ACTIVE',
                short_name: 'ACTIVE'
            },
            {
                title: 'INACTIVE',
                name: 'INACTIVE',
                short_name: 'INACTIVE'
            }
            ,
            {
                title: 'DELETED',
                name: 'DELETED',
                short_name: 'DELETED'
            }
        ]
    }, ],
    controlButtons: ["add", "show"],
    page: 0,
    topicsCount: 1,
    topicsPage: 0,
    markerTopics: null
}

const AdminMarkers = (state = AdminMarkersData, action) => {
    switch(action.type){
        case SET_ADMIN_MARKERS:
            return {...state, markers: action.markers}
        case SET_TOPICS_COUNT:
            return {...state, topicsCount: action.topicsCount}
        case SET_TOPICS_PAGE:
            return {...state, topicsPage: action.topicsPage}
        case SET_MARKER_TOPICS:
            return {...state, markerTopics: action.markerTopics}
        default:
            return {...state}
    }
}

export default AdminMarkers;

export const setAdminMarkers = (markers) => {

    return{
        type: SET_ADMIN_MARKERS,
        markers: markers
    }
}

export const setTopicsCount = (topicsCount) => {
    return{
        type: SET_TOPICS_COUNT,
        topicsCount: topicsCount
    }
}

export const setTopicsPage = (page) => {
    return{
        type: SET_TOPICS_PAGE,
        topicsPage: page
    }
}

export const setMarkerTopics = (markerTopics) => {
    return {
        type: SET_MARKER_TOPICS,
        markerTopics: markerTopics
    }
}

export const getAllMarkers = (pageIndex, pageSize, sortField, sortDirection, status, search = null) => {
    if(status === "ALL"){
        status = "ACTIVE&status=INACTIVE&status=DELETED"
    }
    return (dispatch) => {
        SuperadminService.getMarkers(pageIndex, pageSize, sortField, sortDirection, status, search).then(
            data => {
                dispatch(setAdminMarkers(data))
            }
        ).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
        });
    }
}

export const getMarkerTopics = (accountId) => {
    return (dispatch) => {
        SuperadminService.getMarkerTopics(accountId).then(
            data => {
                dispatch(setMarkerTopics(data))
            }
        )
    }
}

export const detachMarkerTopic = (accountId, topicId) => {
    return (dispatch) => {
        SuperadminService.detachMarkerTopic(accountId, topicId).then(
            data => {
                dispatch(getMarkerTopics(accountId))
            }
        )
    }
}